import { useMutation } from 'react-query';

import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';

export async function exportPortfolioTaggedDirectives(
  orgId: string,
  accreditationBodyId: string,
  accreditationBodyVersionId: string
): Promise<void> {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/organizations/${orgId}/portfolio-assessments/tagged-directives/${accreditationBodyId}/${accreditationBodyVersionId}`;

  await fetcher({
    method: 'post',
    url,
  });
}

export default function usePortfolioExportTaggedDirectives(
  onSuccess?: () => void,
  onError?: (error: ServerErrorResponse) => void
) {
  return useMutation<
    void,
    ServerErrorResponse,
    {
      orgId: string;
      accreditationBodyId: string;
      accreditationBodyVersionId: string;
    }
  >(
    ({ orgId, accreditationBodyId, accreditationBodyVersionId }) =>
      exportPortfolioTaggedDirectives(orgId, accreditationBodyId, accreditationBodyVersionId),
    {
      onSuccess,
      onError,
    }
  );
}
